<div class="login_form">

    <div class="logo">
        <img src="../../../../../assets/images/logo/flowtrics_logo.png">
    </div>

    <div class="title" *ngIf= "!showLoginForm">LOGIN TO YOUR ACCOUNT</div>
    <div class="title" *ngIf= "showLoginForm">Choose an authentication method</div>
    
    <form name="loginForm" [formGroup]="loginForm"  novalidate *ngIf= "!showLoginForm">

        <mat-form-field appearance="fill" *ngIf="!displayValidatorField">
            <mat-label>Email</mat-label>
            <input matInput formControlName="email" type="text" autocomplete="off"  maxlength="50" placeholder="Enter email address" >
            <mat-icon matSuffix class="secondary-text">mail</mat-icon>
            <mat-error *ngIf="loginForm.get('email').hasError('required')">
                Email is required
            </mat-error>
            <mat-error
                *ngIf="!loginForm.get('email').hasError('required') &&
                        loginForm.get('email').hasError('email')">
                Please enter a valid email address
            </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill" *ngIf="!displayValidatorField">
            <mat-label>Password</mat-label>            
               
                <input matInput [type]="hidenew ? 'password' : 'text'" placeholder="Enter new password"
                maxlength="50"  [(ngModel)]="password" (keyup)="checkPassLength()"  
                placeholder="Enter password" formControlName="password" autocomplete="off">
                <mat-icon matSuffix (click)="hidenew = !hidenew" [attr.aria-label]="'Hide password'"
                    [attr.aria-pressed]="hidenew">{{hidenew ? 'visibility_off' : 'visibility'}}</mat-icon>  
                              
                <!-- <mat-error class="errorpass">
                    Please enter password
                </mat-error> -->
           

            <!-- <input matInput type="password"  maxlength="50"  [(ngModel)]="password" (keyup)="checkPassLength()"  
            placeholder="Enter password" formControlName="password">
            <mat-icon matSuffix class="secondary-text">vpn_key</mat-icon> -->
          
            <!-- <mat-error class="errorpass">
                {{ getErrorPasswordLogin() }}
            </mat-error> -->
          
        </mat-form-field>



        <mat-form-field appearance="fill" *ngIf="displayValidatorField">
            <mat-label>Please enter verification code</mat-label>
            <input matInput type="password" maxlength="10" autocomplete="off" [(ngModel)]="tokenValidator" placeholder="Enter verification code" formControlName="tokenValidator" (keyup)="checkValidatorLength()"
            (mouseleave)="copyPasteInputToken()">
            <mat-icon matSuffix class="secondary-text"></mat-icon>
        </mat-form-field>
        

        <div class="remember-forgot-password mb-15" fxLayoutAlign="space-between center" fxLayout="row" *ngIf="!displayValidatorField">
            <mat-checkbox class="remember-me" [checked]="rememberMe" color="primary" aria-label="Remember Me"
            (change)="rememberMeChecked($event)">
                Remember Me
            </mat-checkbox>

            <a class="forgot-password" [routerLink]="'/auth/forgotPassword'" *ngIf="!displayValidatorField">
                Forgot Password?
            </a>
        </div>

        <button type="button" mat-raised-button color="primary" class="submit-button" aria-label="LOG IN" *ngIf="!displayValidatorField"
              (click)="login(loginForm)"  [disabled]="loginForm.invalid || enableLoginButton == false">
            LOGIN
        </button>


        <hr class="line" *ngIf="!displayValidatorField">       

        <button *ngIf="!displayValidatorField" type="button" mat-raised-button color="primary" class="submit-button portalLogin"  routerLink="/auth/portallogin" >
            GO TO GUEST PORTAL
        </button>

        <p class="warning-color" *ngIf="display">
        <span>Account is blocked, you can login after {{display}}
        </span>
        </p>        

        <ng-container *ngIf="displayValidatorField">
            <button mat-raised-button color="primary"  class="submit-button" aria-label="Confirm" 
            (click)="validateToken(tokenValidator)"  [disabled]="!enableConfirmButton">
                Confirm
            </button>
            <span class="back" (click)="showLogin()"> <mat-icon>keyboard_arrow_left</mat-icon> Back to login</span>
        </ng-container>


        <div class="terms">
            <a href="https://flowtrics.com/terms-and-conditions/">Terms & Conditions</a>
            <span></span>
            <a href="https://flowtrics.com/privacy-policy/">Privacy Policy</a>                    
        </div>


    </form>


    <div class="authenticate" *ngIf= "showLoginForm">
        <div class="authinfo" fxLayout="column" >
            <!-- <h2>Choose an authentication method</h2> -->
            <div class="authopt mb-15">               
              <mat-radio-group  class="authopt " aria-label="Select an option" fxLayout="column"
                    fxLayoutAlign="space-between start" (change)="getAuthenticationMethod($event)">
                        <mat-radio-button value="1" color="primary" [checked]="isemailChecked">
                            <div class="thisinfo emailauth" fxLayoutAlign="start center" fxLayout="row">
                                <mat-icon>email</mat-icon>
                                <h3>Get code on email</h3>
                            </div>
                        </mat-radio-button>
                        <mat-radio-button value="2" color="primary" *ngIf= "isPhoneExist==true">
                            <div class="thisinfo smsauth" fxLayoutAlign="start center" fxLayout="row">
                                <mat-icon>stay_current_portrait</mat-icon>
                                <h3>Get code on sms</h3>
                            </div>
                        </mat-radio-button>
                    </mat-radio-group>
                
            </div>
            <button mat-raised-button color="primary" class="submit-button" (click)="loginApiCall()" 
            [disabled]="!ContinueButton"  aria-label="CONTINUE">
                  CONTINUE
            </button>

            <span class="back" (click)="showLogin()"> <mat-icon>keyboard_arrow_left</mat-icon> Back to login</span>

        </div>
    </div>

</div>

<div class="progress-loader" *ngIf="spinner">
    <div class="lds-ripple" ><div></div><div></div></div>
  </div>
